import React from "react"
import Grid from "@mui/material/Grid"
import type { GridProps } from "@mui/material/Grid"
import { SxProps } from '@mui/system';
interface Props extends GridProps {
  sx?: SxProps | undefined;
  children: React.ReactNode;
}

const GridContainer = ({ children, sx, ...rest }: Props) => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        maxWidth: "xl",
        margin: "auto",
        width: "calc(100% + 16px) !important",
        marginLeft: "-16px",
        "& .MuiGrid-item": {
          "& .description": {
            px: 1
          }
        },
        ...(sx || {})
      }}
      {...rest}
    >
      {children}
    </Grid>
  )
}

export { GridContainer }
